import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, Table, TableHead, TableRow, TableCell, TableBody, FormControl, InputLabel, Select, Input, MenuItem } from '@material-ui/core'
import CosturiTipuriList from '../CosturiTipuriList'




export default class AddCosturiProiect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fullScreen: false
    }
  }

  componentDidMount() {
    this.getWindowDimentions()
  }

  getWindowDimentions = () => {
    let windowWidth = window.innerWidth


    this.setState({
      fullScreen: windowWidth <= 800 ? true : false
    })

  }


  render() {
    return (
      <div>
        <Dialog
          className="pm-alert-dialog"
          disableEscapeKeyDown
          fullWidth={true}
          maxWidth='md'
          fullScreen={this.state.fullScreen}
          open={this.props.open}
          onClose={this.props.dialogClose}>
          <DialogActions >
            <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
              <i className='material-icons pm-round-button-text-dialog'>close</i>
            </Fab>
          </DialogActions>
          <h2 style={{ marginBottom: 0 }} className='pm-dialog-alert-title'>{this.props.title}</h2>
          {this.props.showEtape &&
            <div style={{ display: 'flex', width: 200, justifyContent: 'center', marginBottom: 10, margin: 'auto' }}>

              <FormControl className='inputFocus' style={{ width: '90%', marginTop: 16 }}>
                <InputLabel htmlFor="resursa">Selecteaza Etapa</InputLabel>
                <Select

                  value={this.props.etapaSelectata || ""}
                  onChange={this.props.changeEtapa}

                  input={<Input id="resursa" />}>


                  {this.props.etape.map((s, idx) => {
                    return <MenuItem value={s.id} key={idx}  > {s.denumire}</MenuItem>

                  })
                  }
                </Select>
              </FormControl>

            </div>
          }


          <div className='container' style={{ textAlign: 'center', width: '98%', overflow: 'scroll' }}>

            <table style={{ width: '100%', minWidth: 600, tableLayout: 'fixed', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={{ border: '1px solid gray', borderTop: 'none', color: '#6d6d6d' }}>
                    Produs / Serviciu
                            </th>
                  <th style={{ border: '1px solid gray', borderTop: 'none', color: '#6d6d6d' }}>
                    Cantitate
                            </th>
                  <th style={{ border: '1px solid gray', borderTop: 'none', color: '#6d6d6d' }}>
                    Pret Net
                            </th>
                  <th style={{ border: '1px solid gray', borderTop: 'none', color: '#6d6d6d' }}>
                    TVA
                            </th>
                  <th style={{ border: '1px solid gray', borderTop: 'none', color: '#6d6d6d' }}>
                    Total Net
                            </th>
                  <th style={{ border: '1px solid gray', borderTop: 'none', color: '#6d6d6d' }}>
                    Total TVA
                            </th>
                  <th style={{ border: '1px solid gray', borderTop: 'none', color: '#6d6d6d' }}>
                    Total
                            </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ border: '1px solid gray' }}>
                    <input style={{ border: 'none', textAlign: 'center', fontSize: 16, width: '90%', color: '#6d6d6d' }} value={this.props.numeProdus} type="text" name='numeProdus' onChange={this.props.changeCellValue} />
                  </td>
                  <td style={{ border: '1px solid gray' }}>
                    <input style={{ border: 'none', textAlign: 'center', fontSize: 16, width: '90%', color: '#6d6d6d' }} value={this.props.cantitate} type="number" name='cantitate' onChange={this.props.changeCellValue} />
                  </td>
                  <td style={{ border: '1px solid gray' }}>
                    <input style={{ border: 'none', textAlign: 'center', fontSize: 16, width: '90%', color: '#6d6d6d' }} value={this.props.pret} type="number" name='pret' onChange={this.props.changeCellValue} />
                  </td>
                  <td style={{ border: '1px solid gray' }}>
                    <input style={{ border: 'none', textAlign: 'center', fontSize: 16, width: '90%', color: '#6d6d6d' }} value={this.props.tva} type="number" name='tva' onChange={this.props.changeCellValue} />
                  </td>
                  <td style={{ border: '1px solid gray', color: '#6d6d6d', fontSize: 16 }}>
                    {this.props.totalNet.toFixed(2)}
                  </td>
                  <td style={{ border: '1px solid gray', color: '#6d6d6d', fontSize: 16 }}>
                    {this.props.totalTva.toFixed(2)}
                  </td>
                  <td style={{ border: '1px solid gray', color: '#6d6d6d', fontSize: 16 }}>
                    {this.props.total.toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>


            {/* <CosturiTipuriList
                            getTipuriCost={this.props.getTipuriCost}
                            elemente={this.props.costuriTipuri}
                            dict={this.props.dict}
                            onlyColumns={{nume:'nume'}}
                               onElClick={this.props.costAdd} /> */}
          </div>

          <Button disabled={this.props.showEtape ? (this.props.etapaSelectata !== '0'  ? false : true) : false} style={{ margin:'auto', marginTop: 10, width:'fit-content', marginBottom:20 }} onClick={this.props.costAdd} className="pm-adauga-button">

            Salveaza
        </Button>



        </Dialog>
      </div>
    );
  }
}